import { createRouter as createTanStackRouter } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';
import type { QueryClient } from '@tanstack/react-query';

export function createRouter() {
  return createTanStackRouter({
    routeTree,
    context: {
      auth: undefined!,
      queryClient: undefined!,
    },
  });
}

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof createRouter>;
  }
}

